// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyMailSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.782 2.124a1 1 0 0 1 .24 1.05l-6.818 19.018c-.47 1.309-2.313 1.33-2.812.032L9.5 14.702l-7.553-2.905c-1.286-.494-1.28-2.316.008-2.803l18.773-7.093a1 1 0 0 1 1.055.223zM11.436 14.168l2.34 6.082 6.323-15.565s-1.28 1.916-1.692 2.328c-.4.4-6.97 7.155-6.97 7.155zM3.888 10.4l6.129 2.358s6.537-6.722 6.976-7.16c.412-.412 2.307-1.712 2.307-1.712z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyMailSend;
